<template>
  <dashboard-widget title="BOTTLES PRODUCED" :zoomed="zoomed" :width="width" :enableDelete="enableDelete"
                      @zoom="$emit('zoom','DashboardBottlingHistory')"
                      @delete="$emit('delete','DashboardBottlingHistory')"
                      @close="$emit('close')">

    <v-btn-toggle v-model="period" mandatory @change="refresh" style="position:absolute;top:40px;left:10px" :style="zoomed?'top:50px':''">
      <v-btn x-small value="Last30Days">Every 30 days</v-btn>
      <v-btn x-small value="Monthly">By month</v-btn>
    </v-btn-toggle>
    <v-autocomplete :items="[{text:'All',value:'Any'},{text:'> 7% alc./vol.',value:'GT7'},{text:'<= 7% alc./vol.',value:'LE7'}]" v-model="strength" hide-details dense class="text-caption d-inline-block"
              style="position:absolute;top:30px;right:10px;width:100px" :style="zoomed?'top:40px':''" @change="refresh"/>
    <div ref="chart" @click="disableTo ? '' : $router.push({name:'ProductionBottling'})" style="position:relative;top:25px"/>
  </dashboard-widget>
</template>

<script>
import {format,add} from 'date-fns'

export default {
  name: 'DashboardBottlingHistory',
  props: {
    from: {type:String, required:true},
    to: {type:String, required:true},
    zoomed: {type:Boolean, required:false, default:false},
    width: {type:Number, required:false, default:290},
    enableDelete: {type: Boolean, required:false, default:false},
    disableTo: {type: Boolean, required:false, default:false}
  },
  data() {
    return {
      chart: null,
      period: 'Last30Days',
      strength: 'Any',
      summary: [],
      options: {chartArea:{height:this.zoomed?'80%':'95%',width:'90%',left:this.zoomed?50:40},
                fontSize:this.zoomed?12:10,
                height:this.zoomed?415:225,
                colors:['green'],
                vAxis:{format: '#,###',gridlines:{count:3},minorGridLines:{count:0},viewWindowMode:"maximized"},
                hAxis:{textStyle:{color:this.zoomed?'black':'white'},showTextEvery:4},
                legend:{ position: "none"}}
    }
  },
  computed: {
    drawer() {
      return this.$store.state.drawer;
    }
  },
  watch: {
    dark() {
      this.draw();
    },
    drawer() {
      this.draw();
    },
    from() {
      this.refresh();
    },
    to() {
      this.refresh();
    }
  },
  async mounted() {
    if (window.google) {
      window.google.charts.load('current', {'packages':['corechart']});
      window.google.charts.setOnLoadCallback(() => {
        if (this.$refs.chart == undefined)
          return;
        this.chart = new window.google.visualization.LineChart(this.$refs.chart);
        this.refresh();
      });
    }
  },
  methods: {
    async refresh() {
      const results = await this.$apiCall(`query DashboardBottlingHistory($from:Date!, $to:Date!, $period:SummaryPeriod!, $strength:ProductStrength) {
                                            bottlingSummary(from:$from, to:$to, period:$period, strength:$strength) {
                                              totalBottles,periodStart
                                            }
                                          }`, {from:this.from, to:this.to, period:this.period, strength:this.strength});
      if (!results.error) {
        this.summary = results.data.bottlingSummary;
        this.draw();
      }
    },
    draw() {
      if (this.chart === null)
        return;

			const dataLineChart = [["Period","Bottles",{role:"tooltip",type:"string"}]];

      const base = this.period === 'Monthly' ? new Date(format(new Date(), 'yyyy-MM') + '-01T00:00:00') : new Date();
      const dateFormat = this.period === 'Monthly' ? 'yyyy-MM' : 'yyyy-MM-dd';
      let range = 24;
			while (range--) {
        const date = format(add(base, this.period === 'Monthly' ? {months:-1*range} : {days:-30*range}), dateFormat);
        dataLineChart.push([date,0,this.date(date)+'\nBottles: 0']);
      }
      if (this.period !== 'Monthly')
        dataLineChart.splice(24, 1);

      for (const infoline of this.summary) {
        let index = 0;
        while (index < dataLineChart.length)
          if (dataLineChart[index][0] === infoline.periodStart) {
            const line = dataLineChart[index];
            line[1] = infoline.totalBottles;
            line[2] = this.date(line[0]) + "\nBottles: " + this.number(infoline.totalBottles);
            break;
          }
          else
            index++
      }
      const data = window.google.visualization.arrayToDataTable(dataLineChart);
      const textColor = {color:this.darkMode?'#ffffff':'#3d3d3d'};
      this.options.hAxis.textStyle = textColor;
      this.options.hAxis.titleTextStyle = textColor;
      this.options.vAxis.baselineColor = this.darkMode?'#ffffff':'#3d3d3d';
      this.options.vAxis.titleTextStyle = textColor;
      this.options.vAxis.textStyle = textColor;
      this.options.width = this.zoomed ? 480 : this.width-30;
      this.chart.draw(data, {...this.options, backgroundColor:this.darkMode?'#1e1e1e':'white'});
    },
    date(d) {
      if (this.period === 'Monthly')
        return format(new Date(d+'-01T00:00:00'), 'MMMM yyyy');
      return this.$formatDate(d) + ' to ' + this.$formatDate(format(add(new Date(d+'T00:00:00'),{days:29}),'yyyy-MM-dd'));
    },
    number(n) {
      return this.$number(n, 0);
    }
  }
}
</script>